
export const initDNI = (FunnelCommunityID) => {
  try {
    const FunnelApiKey = window.FunnelApiKey;
    if(typeof FunnelApiKey === 'undefined' || FunnelApiKey === null || FunnelApiKey === '') {
      throw "Funnel is not initialized";
    }
    if(typeof FunnelDNI === 'function'){
      FunnelDNI(
        FunnelApiKey,
        FunnelCommunityID,
        function(data) {
          // this will fire when DNI occurs
          // $("#DNIValue").val(data.lead_source_id);
          const DNIValue = document.getElementById("DNIValue");
          if (DNIValue) {
            DNIValue.value = data.lead_source_id;
          }
      });
    }
  } catch (err) {
    console.error(err);
  }
}



// WEBPACK FOOTER //
// ./src/js/api/dni.js